// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthCallbackComponent } from './containers/auth-callback/auth-callback.component';
import { LoginComponent } from './containers/login/login.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'auth',
    component: AuthCallbackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
